module.exports = __webpack_public_path__ + "img/advertisers.10c4d25e.svg";